import styled from 'styled-components';
import { FlexContainer } from '../Container';

type UploadContainerProps = {
  error?: boolean;
};

export const UploadContainer = styled(FlexContainer)<UploadContainerProps>`
  cursor: pointer;
  ${(p) => p.error && `color: ${p.theme.colors.general.error}`};
  & * {
    ${(p) => p.error && `color: ${p.theme.colors.general.error}`};
    cursor: pointer;
  }
`;
